export class FilterCriteria {
    isLox: boolean;
    isHelium: boolean;
    isHydrogen: boolean;
    isLar: boolean;
    isCO2: boolean;
    isSOG: boolean;
    isSOE: boolean;
    isAsu: boolean;
    isHyco: boolean;
    isGeneral: boolean;
    prodActivity: string[];
    specificProcess: string[];
    countryId: string;
    constructor(
        isLox: boolean,
        isHelium: boolean,
        isHydrogen: boolean,
        isLar: boolean,
        isCO2: boolean,
        isSOG: boolean,
        isSOE: boolean,
        isAsu: boolean,
        isHyco: boolean,
        isGeneral: boolean,
        countryId: string) {
        this.isLox = isLox;
        this.isLar = isLar;
        this.isCO2 = isCO2;
        this.isHydrogen = isHydrogen;
        this.isHelium = isHelium;
        this.isSOE = isSOE;
        this.isSOG = isSOG;
        this.isHyco = isHyco;
        this.isAsu = isAsu;
        this.isGeneral = isGeneral;
        this.prodActivity = [];
        this.specificProcess = [];
        this.countryId = countryId;
    }
}